import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecMenuItemTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            root: {
                padding: ".5rem",
                borderRadius: "0.75rem",
                "&.Mui-selected, &.Mui-focused": {
                    background: theme.palette.neutralGray10.main,
                },
                "&:hover, &.Mui-selected:hover": {
                    backgroundColor: theme.palette.neutralGray000.main,
                },
            },
        },
    };
};
